// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ComboPrices_ListaPorFranquiaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /so/combo_prices/lista_por_franquia/{franchise_id}
 * — as linhas de UMA franquia, inativas inclusas (gestao).
 */
import type { ComboPrices_PriceRow } from './ComboPrices_PriceRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ComboPrices_ListaPorFranquiaResponseDados = ComboPrices_PriceRow[];

export type ComboPrices_ListaPorFranquiaResponse = ApiResponse<ComboPrices_ListaPorFranquiaResponseDados>;

registerResponseContract('ComboPrices_ListaPorFranquiaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_combo_price_id:           { type: 'number',  required: true },
      so_combo_price_combo_id:     { type: 'number',  required: false },
      so_combo_price_franchise_id: { type: 'number',  required: false },
      so_combo_price_price:        { type: 'number',  required: false },
      so_combo_price_active:       { type: 'number',  required: false },
      so_combo_price_created_at:   { type: 'string',  required: false },
      so_combo_name:               { type: 'string',  required: false },
      so_combo_service_id:         { type: 'number',  required: false },
      so_combo_priority_id:        { type: 'number',  required: false },
      so_combo_quantity:           { type: 'number',  required: false },
      so_combo_validity_days:      { type: 'number',  required: false },
      so_combo_active:             { type: 'number',  required: false },
      so_service_name:             { type: 'string',  required: false },
      so_priority_name:            { type: 'string',  required: false },
    },
  },
})
